<template>
  <address :class="[defaultClasses, customClasses]" class="not-italic" :qaid="qaid">
    <p v-if="fullName">{{ fullName }}</p>
    <p>{{ address.line1 }}</p>
    <p v-if="address.line2">{{ address.line2 }}</p>

    <p v-if="locale === 'kr'">{{ postalCode }}</p>

    <p v-else-if="isAlternateAddressFormat">{{ postalCode }}&nbsp;{{ town }}</p>

    <p v-else-if="locale === 'jp'">
      <span v-if="regionName">{{ regionName }}</span>
      <span v-else-if="address.regionText">{{ address.regionText }}</span>
      <span>&nbsp;{{ postalCode }}</span>
    </p>

    <p v-else class="flex flex-wrap">
      <span>{{ town }}</span>
      <span v-if="regionName">,&nbsp;{{ regionName }}</span>
      <span v-else-if="address.regionText">,&nbsp;{{ address.regionText }}</span>
      <span>,&nbsp;{{ postalCode }}</span>
    </p>
  </address>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'AddressSummary',
  props: {
    address: {
      type: Object,
      default: () => ({}),
    },
    qaid: {
      type: String,
      default: '',
    },
    customClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      reverseFullNameLocale: ['jp'],
    };
  },
  computed: {
    ...mapState('backend', ['locale']),
    isAlternateAddressFormat() {
      return this.locale === 'de' || this.locale === 'at' || this.locale === 'deelectra' || this.locale === 'atelectra';
    },
    regionName() {
      return this.address.region?.name || this.address?.regionName;
    },
    fullName() {
      let fullNameValue = '';

      if (this.address.firstName && this.address.lastName) {
        if (this.reverseFullNameLocale.includes(this.locale)) {
          fullNameValue = `${this.address.lastName} ${this.address.firstName}`;
        } else {
          fullNameValue = `${this.address.firstName} ${this.address.lastName}`;
        }
      }
      return fullNameValue;
    },
    defaultClasses() {
      return {
        'mb-2': !this.customClasses,
      };
    },
    postalCode() {
      return this.address?.postalCode || this.address?.postcode;
    },
    town() {
      return this.address?.town || this.address?.townCity;
    },
  },
};
</script>
